/* A search result row: name and number on the first line, details below. */
.result {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0 var(--space-4);
  width: 100%;
  padding: var(--space-1) 0;
}

.resultName {
  font: var(--t-body-strong);
  overflow-wrap: anywhere;
}

.resultNumber {
  justify-self: end;
}

.resultMeta {
  display: flex;
  flex-wrap: wrap;
  grid-column: 1 / -1;
  gap: 0 var(--space-4);
  color: var(--graphite);
  font: var(--t-small);
}

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.panelHeading {
  font: var(--t-heading);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

/* Check-in: visit type and payer side by side, the first queue and SHA cover full width. */
.checkInGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: var(--space-3) var(--space-6);
  align-items: start;
}

.checkInWide {
  grid-column: 1 / -1;
  min-width: 0;
}

.readOnly {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.readOnlyLabel {
  font: var(--t-body-strong);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.candidateList {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.candidate {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--rule);
}

.reasonList {
  margin: 0;
  padding-left: var(--space-5);
  font: var(--t-small);
}

.registration {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

/* The draft line at the top of the form takes no room until there is a draft to mention;
   its status stays in the page so screen readers hear "Saved on this device". */
.draftBar:not(:has(button)):has(> [role='status']:empty) {
  margin-bottom: calc(-1 * var(--space-5));
}

/* The field groups fill the card: two columns where the page is wide, one on a laptop
   in a narrow window or a phone. Groups stay in reading order, left to right. */
.registrationGroups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 440px), 1fr));
  gap: var(--space-6) var(--space-7);
  align-items: start;
}

.row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--space-4);
  align-items: start;
}

.identifierRow {
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr) auto;
  gap: var(--space-3);
  align-items: end;
}

.identifierRow[data-passport] {
  grid-template-columns: 200px minmax(0, 1fr) 120px auto;
}

.consentText {
  padding: var(--space-3) var(--space-4);
  border-left: 3px solid var(--ink);
  background: var(--wash);
  white-space: pre-wrap;
}

.draftStatus {
  color: var(--graphite);
  font: var(--t-small);
}

.chosen {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--rule);
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.recordList,
.history {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.recordItem {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-4);
  min-width: 0;
  min-height: var(--row-height);
  padding: var(--space-1) 0;
  border-bottom: 1px solid var(--rule);
  overflow-wrap: anywhere;
}

/* Entered in error stays visible (never deleted), struck through with its reason. */
.recordItem[data-entered-in-error] > :first-child {
  text-decoration: line-through;
}

.inlineForm {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4) 0;
}

.historyItem {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}

.details {
  display: grid;
  grid-template-columns: 12rem minmax(0, 1fr);
  gap: var(--space-2) var(--space-4);
  margin: 0;
}

@media (width < 640px) {
  .details {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .details dd {
    margin-bottom: var(--space-3);
  }
}

.details dt {
  color: var(--graphite);
}

.details dd {
  margin: 0;
}

.record {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

/* The patient page's header links: check in, records request, access log. */
.headerLinks {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-4);
}
